import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, InteractionType, KeyValueId, LocalService, NumericConfig, OtpType, PageKey, QrType, RazorPayCustomerResponse, RelationShipRole, Status } from 'src/service/local.service';
import { PaymentManagementService } from 'src/service/payment-management.service';

@Component({
  selector: 'app-payment-gateway-customer',
  templateUrl: './payment-gateway-customer.component.html',
  styleUrl: './payment-gateway-customer.component.scss'
})
export class PaymentGatewayCustomerComponent {
  lstSectionConfigKeys: string[] = ["payment_gateway_cust_config"];
  ctryCode: string = ''; businessId: string = ''; userId: string = ''; interactionType = 0; maxBodyHeight = 0;
 isMobileOtpVerified = false; isEmailOtpVerified = false;
  wrapper?: RazorPayCustomerResponse; confirmAccountNumber: string = ''; sampleAmount: number | null = null;
  contactPrefix: string = ''; contactLength: number = 0; otpType = OtpType; isShowMobileOtpPopup = false; isShowEmailOtpPopup = false; isGenerateQr: boolean = false;
  qrTypes: KeyValueId[] = []; RelationShipRole = RelationShipRole;

  htmlId: string = ''; elementIds: any;
  numericConfig: NumericConfig = {} as NumericConfig;

  constructor(public localService: LocalService, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private configurationManagementService: ConfigurationManagementService, private languageManagementService: LanguageManagementService, private paymentService: PaymentManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      name: 'gateway_customer_name_' + this.htmlId,
      contact: 'gateway_customer_contact_' + this.htmlId,
      email: 'gateway_customer_email_' + this.htmlId,
      gst: 'gateway_customer_gst_' + this.htmlId,
      bk_acct_num: 'gateway_customer_bank_acct_num_' + this.htmlId,
      bk_acct_num_conf: 'gateway_customer_bank_acct_num_conf_' + this.htmlId,
      bk_acct_name: 'gateway_customer_bank_acct_name_' + this.htmlId,
      bk_acct_ifsc: 'gateway_customer_bank_acct_ifsc_' + this.htmlId,
      create: 'gateway_customer_create_' + this.htmlId,
      verify_contact: 'gateway_customer_verify_contact' + this.htmlId,
      verify_email: 'gateway_customer_verify_email_' + this.htmlId,
      test_qr: 'gateway_customer_test_qr_' + this.htmlId,
      amount: 'gateway_customer_amount_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.userId = routeParams.userId;
      this.configurationManagementService.ensurePageActions(PageKey.PaymentGatewayCustomer, this.businessId);
      if (this.interactionType != InteractionType.User && (!this.businessId || this.businessId.length < 5)) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.contactPrefix = this.localService.getContactPrefixByCountryCode(this.localService.getLoginAsCountryCode() );
    this.contactLength = this.localService.getContactMaxDigitByCountryCode(this.localService.getLoginAsCountryCode() );
    this.numericConfig.maxDigits = this.contactLength;

    this.qrTypes = Object.entries(QrType).map(([key, value]) => ({
      key,
      value
    }));
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.paymentService.getPaymentGatewayCustomer(this.businessId, true).subscribe(result => {
        this.wrapper = result;
        if (this.wrapper && this.wrapper.Id) {
          this.confirmAccountNumber = this.wrapper.FundAccount.BankAccountNumber;
          this.onFocus();
        }
      });
    }
  }

  onFocus() {
    this.localService.onFocusNextInput(this.elementIds.amount, FocusInputType.TextBox);
  }

  onAction(index: number) {
    switch (index) {
      case 2: {
        //Create
        this.paymentService.savePaymentGatewayCustomer(this.wrapper).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.onLoad();
          }
        });
      } break;
      case 3: {
        this.isShowMobileOtpPopup = true;
      } break;
      case 4: {
        this.isShowEmailOtpPopup = true;
      } break;
      case 5: {
        this.isGenerateQr = true;
      } break;
      case 6: {
        //Save selected qr type
        this.paymentService.savePaymentQrType(this.businessId, this.wrapper?.QrType).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          this.onFocus();
        });
      } break;
      case 7: {
        //Savr bank account
        this.paymentService.SavePaymentGatewayCustomerFundAccountExternal(this.wrapper.Id, this.wrapper).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.onLoad();
          }
        });
      } break;
    }
  }

  onVerifiedOtp(e, otpType: OtpType) {
    switch (otpType) {
      case OtpType.MobileVerification: {
        this.isMobileOtpVerified = true;
      } break;
      case OtpType.UpdateUserEmail: {
        this.isEmailOtpVerified = true;
      } break;
    }
    this.isShowMobileOtpPopup = false;
    this.isShowEmailOtpPopup = false;
  }
}
